// /src/modules/identityKey.ts
import type { Me } from "../core/me";

export function makeIdentityKey(me: Me): string {
  const provider = (me.provider ?? "").trim();
  const tenantId = (me.tenantId ?? "").trim();
  const userId = (me.userId ?? "").trim();
  return `${provider}|${tenantId}|${userId}`;
}
